import * as React from 'react';
import {connect} from 'react-redux';

import _ from 'underscore';
// @ts-expect-error
import capitalize from 'underscore.string/capitalize';

import type {FilterObject} from 'nutshell-core/types';

import type {NutshellState} from '../../../store';

import {StickyScrollEntityListContainer} from '../../core/entity-list/sticky-scroll-entity-list-container';
// @ts-expect-error
import * as dashboardActions from '../../master-dashboard/dashboard-actions';
// @ts-expect-error
import {getLeadsSchema} from '../../master-dashboard/dashboard-selectors';

import {getReportDefaultFields, SEGMENTS} from '../report-constants';
import {ReportTabs} from '../report-tabs';
import type {LeadsReportKey, ReportFacet, ReportSegment} from '../report-types';
import * as actions from '../reports-actions';
import * as selectors from '../reports-selectors';

import {ReportDetailsTable} from './report-details-table';

type OwnProps = {
    filters: FilterObject[];
    facet: ReportFacet;
    segmentId?: ReportSegment;
    selectedTab: string;
    reportKey: LeadsReportKey;
    location: any;
    selectedPage: number;
    selectedSortField: string;
    selectedFields: Array<string>;
    onParamChange: (arg1: any, arg2: boolean) => any;
};

type StateProps = {
    schema: any;
    count: number;
    isFirstLoad: boolean;
    isLoading: boolean;
    hasError: boolean;
    listItems: any[];
};

type DispatchProps = {
    fetchLeadsList: (
        arg1: FilterObject[],
        arg2: number,
        arg3: string[],
        sort: string,
        reportKey: LeadsReportKey
    ) => any;
    fetchLeadsSchema: () => void;
};

type Props = OwnProps & StateProps & DispatchProps;

type State = {
    stickyHeaderTop: number | null | undefined;
};

function mapStateToProps(state: NutshellState): StateProps {
    return {
        schema: getLeadsSchema(state),
        isFirstLoad: selectors.getLeadsListIsFirstLoad(state),
        isLoading: selectors.getLeadsListIsLoading(state),
        hasError: selectors.getLeadsListHasError(state),
        listItems: selectors.getLeadsListItems(state),
        count: selectors.getLeadsListLeadCount(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        fetchLeadsSchema: () => {
            dispatch(dashboardActions.fetchLeadsSchema());
        },
        fetchLeadsList: (
            filters: FilterObject[],
            pageNum: number,
            columns: Array<string>,
            sort: string,
            reportKey: LeadsReportKey
        ) => {
            dispatch(
                actions.requestReportLeadsListData({filters, pageNum, columns, sort, reportKey})
            );
        },
    };
}

function getSegmentLabel(segmentId?: ReportSegment | null): string {
    if (!segmentId) {
        return 'Date';
    }

    const segment = SEGMENTS.find((s) => s.id === segmentId);

    return segment ? segment.label : capitalize(segmentId);
}

class DetailViewContainerComponent extends React.Component<Props, State> {
    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            stickyHeaderTop: null,
        };
    }

    UNSAFE_componentWillMount() {
        this.props.fetchLeadsSchema();
    }

    componentDidMount() {
        this.props.fetchLeadsList(
            this.props.filters,
            this.props.selectedPage,
            this.props.selectedFields,
            this.props.selectedSortField,
            this.props.reportKey
        );
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        const reportKeyChanged = this.props.reportKey !== nextProps.reportKey;
        const filtersChanged =
            JSON.stringify(nextProps.filters) !== JSON.stringify(this.props.filters);
        const pageWasChanged = nextProps.selectedPage !== this.props.selectedPage;
        const sortWasChanged = nextProps.selectedSortField !== this.props.selectedSortField;

        // Need to sort the new and old columns so that changes in order do _not_
        // trigger another (unnecessary) fetch.
        const oldFieldsSorted = _.sortBy(this.props.selectedFields, (fieldName) => fieldName);
        const newFieldsSorted = _.sortBy(nextProps.selectedFields, (fieldName) => fieldName);
        const fieldsChanged = JSON.stringify(newFieldsSorted) !== JSON.stringify(oldFieldsSorted);

        if (
            reportKeyChanged ||
            filtersChanged ||
            fieldsChanged ||
            pageWasChanged ||
            sortWasChanged
        ) {
            this.props.fetchLeadsList(
                nextProps.filters,
                nextProps.selectedPage,
                nextProps.selectedFields,
                nextProps.selectedSortField,
                nextProps.reportKey
            );
        }
    }

    render() {
        const tabs = [
            {
                id: 'details',
                label: 'Details',
                pathname: `/reports/${this.props.reportKey}/details`,
                exact: true,
            },
            {
                id: 'leads',
                label: 'Leads',
                pathname: `/reports/${this.props.reportKey}/leads`,
                exact: true,
            },
        ];

        const tabContents = [
            {
                id: 'details',
                body: (
                    <ReportDetailsTable
                        facet={this.props.facet}
                        title={getSegmentLabel(this.props.segmentId)}
                    />
                ),
            },
            {
                id: 'leads',
                body: (
                    <StickyScrollEntityListContainer
                        count={this.props.count}
                        isFirstLoad={this.props.isFirstLoad}
                        isLoading={this.props.isLoading}
                        hasError={this.props.hasError}
                        filters={this.props.filters}
                        listItems={this.props.listItems}
                        schema={this.props.schema}
                        defaultFields={getReportDefaultFields(this.props.reportKey).split(',')}
                        entityType='leads'
                        // @ts-expect-error
                        facet={this.props.facet}
                        segmentId={this.props.segmentId}
                        selectedTab={this.props.selectedTab}
                        location={this.props.location}
                        selectedPage={this.props.selectedPage}
                        selectedSortField={this.props.selectedSortField}
                        selectedFields={this.props.selectedFields}
                        onParamChange={this.props.onParamChange}
                        stickyHeaderTop={this.state.stickyHeaderTop}
                        includeColumnPicker={true}
                        tabsSelector='#report-tabs'
                        scrollContainerSelector='#report-content-scroll-container'
                    />
                ),
            },
        ];

        return (
            <ReportTabs
                selectedTab={this.props.selectedTab}
                location={this.props.location}
                onStickyChange={this.setStickyHeaderTop}
                tabContents={tabContents}
                tabs={tabs}
            />
        );
    }

    setStickyHeaderTop = (top?: number | null) => {
        this.setState({stickyHeaderTop: top});
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const DetailViewContainer = connector(DetailViewContainerComponent);
